import { Controller, useFormContext } from 'react-hook-form'

import { FF2, TextInput } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const LEContactPhone = () => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name="institutionContactInfo.leContactPhone"
      control={control}
      render={({ field }) => (
        <FF2
          label="91. LE contact phone number (Include Area Code)"
          field={field}
          input={(props) => <TextInput {...props} maxLength={16} />}
        />
      )}
    />
  )
}
